import axios from "axios";
import Spinner from "./spinner";
import {toastAlert} from "./toastAlert";
import {confirmModal} from "./confirmModal";
import * as $ from "jquery";
import moment from "moment";
import flatpickr from "flatpickr";
import {Polish} from 'flatpickr/dist/l10n/pl.js';
import {handleCheckAllStateChange} from "./tables";
import {polishPlurals} from "./utilities";
import {validateHTMLColorHex} from "validate-color";

import tinymce from "tinymce";
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce-i18n/langs/pl';
require.context(
    'file-loader?name=[path][name].[ext]&context=node_modules/tinymce!tinymce/skins',
    true,
    /.*/
);
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";

let anyForm = $('form');

// Handle errors
export const handleValidationErrors = (errors, dom = body) => {
    for (let error in errors) {
        if (!errors.hasOwnProperty(error)) {
            continue;
        }

        let errorSpan = dom.find(`.error[data-for='${error}']`);
        errorSpan.text(errors[error]);
    }
}

export const clearErrors = (dom = $('body')) => {
    dom.find('.error').text("");
}

export const tokenInput = () => {
    return `<input type="hidden" name="_token" value="${$('meta[name="csrf-token"]').attr('content')}" />`;
}

// Alert before leave with unsaved changes.
// Timeout, so it does not catch automated triggers
let unsubmittedForms = [];

setTimeout(() => {
    $(":input").change(function() {
        if($(this).attr('type') === 'search') {
            return;
        }

        let form = $(this).closest('form');
        let id = form.attr('id');

        if(typeof id == 'undefined' || !id || unsubmittedForms.includes(id)) {
            return;
        }

        unsubmittedForms = [...unsubmittedForms, id]
    })
}, 2000)

anyForm.submit(function() {
    unsubmittedForms = unsubmittedForms.filter(id => id !== $(this).attr('id'));
})

$(document).ready(function() {
    window.onbeforeunload = function(){
        if(unsubmittedForms.length > 0) {
            return 'Posiadasz niezapisane zmiany. Czy jesteś pewny/a, że chcesz wyjść?'
        }
    };
})

let submittedForms = [];
let disabledButtons = [];

export const disableButtons = (button = null) => {
    if(button === null) {
        button = $(document.activeElement);
    }

    if(button.length > 0 && button.is('button')) {
        button.attr('disabled', true);
        button.data('old_html', button.html());
        button.html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`);
    }

    disabledButtons = [...disabledButtons, button];

    $('button:not([disabled]), a.btn:not([disabled])').attr('disabled', true).each(function() {
        disabledButtons = [...disabledButtons, this];
    });
}

export const enableFormBack = (form = null) => {
    if(form === null) {
        form = anyForm;
    } else {
        form = $(form);
    }

    form.each(function() {
        let id = $(this).attr('id');
        submittedForms = submittedForms.filter(el => el !== id);
    })

    for(let button of disabledButtons) {
        button = $(button);

        button.attr('disabled', false);
        button.html(button.data('old_html'));
    }

    disabledButtons = [];
}

// Disable submit buttons
anyForm.submit(function(e) {
    if($(this).data('async') === true || $(this).data('disable_on_submit') === false) {
        return;
    }

    let id = $(this).attr('id');
    if(submittedForms.includes(id)) {
        e.preventDefault();
        return;
    }

    submittedForms = [...submittedForms, id];
    disableButtons();

    setTimeout(() => {
        if($(this).data('async') === true) {
            enableFormBack(this);
        }
    }, 100);

    setTimeout(() => {
        if($(this).data('async') === true) {
            enableFormBack(this);
        }
    }, 500);
})

/**
 * Handle API form submission
 * @param form
 * @param {function(Object)} callback
 * @param preSubmit
 * @param {function} errCallback
 */
export const handleApiForm = (form, callback = null, preSubmit = null, errCallback = null) => {
    $(form).data('async', true);

    const fn = async (el) => {
        clearErrors($(el));
        $(el).data('async', true);

        if (preSubmit !== null && typeof preSubmit == 'function') {
            try {
                await preSubmit($(el));
            } catch (err) {
                if (typeof errCallback == 'function') {
                    errCallback(err)
                }
                return;
            }
        }

        let spinner = new Spinner();

        try {
            let response = await axios.post($(el).attr('action'), $(el).serialize());
            if (response.data.code !== 200) {
                if (response.data.errors) {
                    handleValidationErrors(response.data.errors, $(el));
                    spinner.destroy();
                }

                return;
            }

            spinner.destroy();
            if (callback) {
                callback({form, response});
            }
        } catch (err) {
            spinner.destroy();
            if (typeof errCallback == 'function') {
                errCallback(err)
                return;
            }

            console.log(err)

            toastAlert('Wystąpił błąd podczas zatwierdzania formularza.', {type: 'danger'})
        }
    }

    if(typeof form == 'string') {
        $('body').on('submit', form, async function(e) {
            e.preventDefault();
            await fn(this);
        })
        return;
    }

    form.submit(async function (e) {
        e.preventDefault();
        await fn(this);
    })
}

/**
 * Fill form inputs with data
 * @param form
 * @param data
 * @param triggerChange
 */
export const fillFormInputs = (form, data, triggerChange = false) => {
    form = $(form);

    let inputs = form.find('input');
    inputs = [...inputs, ...form.find('textarea'), ...form.find('select')];

    for (let input of inputs) {
        input = $(input);

        const change = () => {
            if(triggerChange) {
                input.change();
            }
        }

        let name = input.attr('name');
        if (typeof data[name] == 'undefined') {
            continue;
        }

        if(name === '_token') {
            continue;
        }

        let value = data[name];

        if (input.attr('type') === 'checkbox') {
            input.prop('checked', parseInt(value) === 1);
            change();
            continue;
        }

        if (input.attr('type') === 'text' || input.attr('type') === 'number' || input.attr('type') === 'hidden') {
            input.val(value);
            change();
            continue;
        }

        if (input.is('textarea')) {
            input.val(value);
            change();
            continue;
        }

        if (input.is('select')) {
            input.find(`option`).attr('selected', false);
            input.attr('data-selected', value);
            input.find(`option[value="${value}"]`).attr('selected', true);
            change();
        }
    }
}

export const emptyForm = (form) => {
    form = $(form);
    form.find('input, textarea, select').val('');
}

export const hideField = (form, name) => {
    form.find(`[name="${name}"]`).closest('[class^=col-]').hide();
}

export const showField = (form, name) => {
    form.find(`[name="${name}"]`).closest('[class^=col-]').show();
}

// Drag and drop files upload
let fileLists = [];

let isAdvancedUpload = function () {
    let div = document.createElement('div');
    return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
}();

let renderList = (input) => {
    let table = $(`.dragndrop__table[data-for="${$(input).attr('name')}"] tbody`);
    table.empty();

    let multiple = false;
    if ($(input).attr('multiple')) {
        multiple = true;
    }

    let files = fileLists[$(input).attr('name')];
    if (files) {
        for (let file of files) {
            let tableElement = $(`<tr data-id="${file.id}" />`);
            let mainCell = $('<td style="word-break: break-all;" />');
            tableElement.append(mainCell);
            table.append(tableElement);

            mainCell.append('<i class="fas fa-file fa-1x me-2"></i>')
            mainCell.append(file.name)

            tableElement.append(`
                <td class="text-end">
                    <button style="min-width: 62px;" class="btn btn-sm btn-danger btnDeleteFile"><i class="fas fa-trash me-2"></i>Usuń</button>
                </td>
            `);

            if (!multiple) {
                break;
            }
        }
    } else {
        files = [];
    }

    let max = $(input).data('max') || 0;
    if ((!multiple && files.length > 0) || (files.length >= max && max !== 0)) {
        $(input).closest('.input__dragndrop').hide();
    } else {
        $(input).closest('.input__dragndrop').show();
    }
}

let input_dragndrop = $(".input__dragndrop");

if (isAdvancedUpload) {
    let inputs = input_dragndrop;
    inputs.addClass('has-advanced-upload');

    inputs.each(function () {
        renderList($(this).find('input'));

        let form = $(this).closest('form');
        let box = $(this).closest('.input__dragndrop');

        form.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
        })
            .on('dragover dragenter', function () {
                box.addClass('is-dragover');
            })
            .on('dragleave dragend drop', function () {
                box.removeClass('is-dragover');
            })
            .on('drop', function (e) {
                $(this).find('input[type="file"]').prop("files", e.originalEvent.dataTransfer.files).trigger('change');
            });
    })
}

let checkIfMimeValid = (file, types) => {
    if (typeof types != 'object') {
        types = types.split(',');
    }

    return types.includes(file.type);


}

input_dragndrop.each(function () {
    let name = $(this).find('input').attr('name');
    let url = $(this).data('url');

    let nameWithoutBrackets = name.split('[')[0];

    $(this).closest('form').on('submit', async function (e) {
        if($(this).data('no-upload') === true) {
            return;
        }

        clearErrors($(this));
        e.preventDefault();

        let response;

        if (typeof fileLists[name] != 'undefined' && fileLists[name].length > 0) {
            let formData = new FormData();
            let index = 0;
            for (let file of fileLists[name]) {
                if(file.uploaded) {
                    continue;
                }

                formData.append(nameWithoutBrackets + '#' + index, file);
                index++;
            }

            if(index !== 0) {
                let spinner = new Spinner();
                response = await axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                spinner.destroy();

                if (response.data.code !== 200) {
                    handleValidationErrors(response.data.errors, $(this));
                    enableFormBack(this);
                    return;
                }

                for (let file of response.data.files) {
                    let num = $(this).find(`input.hidden_file[data-type="id"]`).length + 1;
                    $(this).append(`<input data-id="${file.id}" data-type="id" class="hidden_file" type="hidden" name="${nameWithoutBrackets}[${num}][id]" value="${file.id}" />`)
                    $(this).append(`<input data-id="${file.id}" data-type="name" class="hidden_file" type="hidden" name="${nameWithoutBrackets}[${num}][name]" value="${file.original_name}" />`)
                    $(this).append(`<input data-id="${file.id}" data-type="type" class="hidden_file" type="hidden" name="${nameWithoutBrackets}[${num}][type]" value="${file.mime}" />`)
                    $(this).append(`<input data-id="${file.id}" data-type="to_delete" class="hidden_file" type="hidden" name="${nameWithoutBrackets}[${num}][to_delete]" value="false" />`)
                }
            }
        }

        let event = $(this).find('.input-wrapper').data('event');
        if(event) {
            if(typeof fileLists[name] != 'undefined') {
                for (let file of fileLists[name]) {
                    file.uploaded = true;
                }
            }

            let form = $(this);
            $(this).trigger('file_submit', {response, callback: function() {
                    form.find('input[data-id][data-type="to_delete"][value="true"]').each(function() {
                        let id = $(this).data('id');
                        form.find('input[data-id]').each(function() {
                            if($(this).data('id') === id) {
                                $(this).remove();
                            }
                        })
                    })
                }});
            return;
        }

        this.submit();
    })
})

$(".hidden_file[data-type='id']").each(function () {
    let id = $(this).data('id');
    let file = {
        id,
        name: $(this).parent().find(`[data-type="name"][data-id="${id}"]`).val(),
        type: $(this).parent().find(`[data-type="type"][data-id="${id}"]`).val(),
        to_delete: $(this).parent().find(`[data-type="to_delete"][data-id="${id}"]`).val() === "true",
        uploaded: true
    }

    let input = $(this).closest('.input__dragndrop').find('input[type="file"]');
    let name = input.attr('name');
    if (typeof fileLists[name] == 'undefined') {
        fileLists[name] = [];
    }

    fileLists[name].push(file);
    renderList(input);
})

$("body").on('click', '.btnDeleteFile', async function (e) {
    e.preventDefault();

    let confirmed = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć ten załącznik?', {color: 'danger'});
    if (!confirmed) {
        return;
    }

    let input = $(this).closest('div.input-wrapper').find('input[type="file"]');
    let row = $(this).closest('tr');

    let files = fileLists[$(input).attr('name')];
    let index = files.findIndex(file => file.id === $(row).data('id'));

    if (files[index].uploaded) {
        $(this).closest('div.input-wrapper').find(`.hidden_file[data-id="${files[index].id}"][data-type="to_delete"]`).val("true");
    }

    input.closest('form').trigger('file_delete', files[index]);

    files.splice(index, 1);
    renderList(input);
})

$("input[type='file'].dragndrop").change(function () {
    let max = $(this).data('max') || 0;

    let files = fileLists[$(this).attr('name')];
    if (typeof files == 'undefined') {
        files = [];
    }

    for (let file of $(this).prop('files')) {
        file.id = files.length + 1;

        let types = $(this).attr('accept') || null;
        if (types && !checkIfMimeValid(file, types)) {
            toastAlert(`Plik ${file.name} nie może zostać dodany.`, {type: "danger"});
            continue;
        }

        let allowedSize = $(this).data('max_size') || 0;
        if (allowedSize !== 0 && (file.size / 1024) > allowedSize) {
            toastAlert(`Plik ${file.name} przekracza dozwolony rozmiar (${allowedSize / 1024}MB)`, {type: "danger"});
            continue;
        }

        files.push(file);
    }

    if (!$(this).attr('multiple')) {
        if(files.length > 0) {
            files = [files[0]];
        }
    } else {
        if (files.length > max && max !== 0) {
            let toRemove = files.length - max;
            files.splice(files.length - toRemove, toRemove);

            toastAlert('Przekroczono dozwoloną liczbę załączników', {type: 'danger'});
        }

        // Remove duplicates
        files = files.filter((file, index, self) =>
                index === self.findIndex((t) => (
                    t.lastModified === file.lastModified && t.name === file.name
                ))
        )
    }

    fileLists[$(this).attr('name')] = files;
    renderList($(this));
    $(this).closest('form').trigger('file_added');
})

// Handling modalSelect option select

let selectTable = $('.to_be_initialized');

function modalSelectBtnClickEvent() {
    $(".modalSelect__button button[data-id]").click(function () {
        let id = $(this).data('id');
        let text = $(this).closest('tr').find('.modalSelect__text').text();
        let modal = $(this).closest('.modal');
        let inputId = modal.data('for');
        let container = $(`.modalSelect__container[data-id="${inputId}"]`);
        container.find('.modalSelect__text').text(text);
        container.find('.modalSelect__input').val(id).trigger('change');

        selectTable.DataTable().$(`button[data-id]`).attr('disabled', false);
        selectTable.DataTable().$(`button[data-id="${id}"]`).attr('disabled', true);

        let modalInstance = bootstrap.Modal.getInstance(modal[0]);
        if (modalInstance) {
            modalInstance.hide()
        }
    })
}

if(selectTable.length === 0) {
    modalSelectBtnClickEvent();
} else {
    selectTable.DataTable({
        "drawCallback": modalSelectBtnClickEvent
    })
}

// Datetime picker for form inputs
$(".datetimepicker").each(function () {
    let enableTime = $(this).data('with_time') === true;
    let time_only = $(this).data('time_only') === true;
    let dateFormat = $(this).data('format') || (with_time ? "d/m/Y H:m" : "d/m/Y");

    let that = this;
    let form = $(this).closest('form');

    let minDate = $(this).data('min_date') ? moment(parseInt($(this).data('min_date')) * 1000).formatPHP(dateFormat) : null;
    let maxDate = $(this).data('max_date') ? moment(parseInt($(this).data('max_date')) * 1000).formatPHP(dateFormat) : null;

    let range = $(this).data('range_field') ?? false;
    let rangeOptions = {};

    if(range) {
        rangeOptions = {
            plugins: [
                new rangePlugin({
                    input: `form#${form.attr('id')} input[name="${range}"]`
                })
            ],
            // mode: 'range',
            // defaultDate: [$(this).val(), $(this).data('range_value')],
        }
    }

    let valueChanged = false;

    let picker = flatpickr($(this)[0], {
        locale: Polish,
        dateFormat,
        enableTime,
        disableMobile: true,
        minDate,
        maxDate,
        allowInput: true,
        time_24hr: true,
        noCalendar: time_only,
        ...rangeOptions,

        onValueUpdate: () => {
            valueChanged = true;
            setTimeout(() => {
                valueChanged = false
            }, 500);
        },

        onChange: (a, b) => {
            if(b === "" && valueChanged) {
                toastAlert('Wprowadzona data jest niepoprawna', {type: 'danger'})
            }
        }
    });

    if ($(this).data('hide_minutes') === true) {
        $(picker.timeContainer).find('.flatpickr-time-separator').hide();
        $(picker.timeContainer).find('.flatpickr-minute').parent().hide();
    }

    $(this).next('.datepicker-icon').click(function() {
        $(that).trigger('click');
    })
})

const invertCheckbox = (input) => {
    $(input).prop('checked', !$(input).prop('checked')).trigger('change');
}

// Transfer
let transferTable = $('.transfer-table');
let transferContainer = $('.transfer-container');
if (transferContainer.length > 0) {
    const checkButtonsState = (container) => {
        container = $(container);

        if(container.find('.transfer-source-input:checked').length > 0) {
            container.find('.transfer-right').attr('disabled', false);
        } else {
            container.find('.transfer-right').attr('disabled', true);
        }

        if(container.find('.transfer-destination-input:checked').length > 0) {
            container.find('.transfer-left').attr('disabled', false);
        } else {
            container.find('.transfer-left').attr('disabled', true);
        }
    }

    const updateCounter = (id) => {
        let transfer = $(`.form-transfer[data-for="${id}"]`);

        let count = transfer.find('.transfer-hidden').length;
        transfer.find('.transfer-counter').text(count);
        transfer.find('.transfer-counter__text').text(polishPlurals(transfer.data('lang_1'), transfer.data('lang_2'), transfer.data('lang_3'), count));
    }

    $('.transfer-check_all').change(function () {
        let table = $(this).closest('table');
        let state = $(this).prop('checked');
        if (state) {
            table.find('tbody input[type="checkbox"]:not(:disabled)').prop('checked', true).trigger('change');
        } else {
            table.find('tbody input[type="checkbox"]:not(:disabled)').prop('checked', false).trigger('change');
        }
    })

    transferTable.on('click', 'tr.transfer-element', function (e) {
        if (!$(e.target).is('input')) {
            if (!$(this).find('input[type="checkbox"]').attr('disabled')) {
                invertCheckbox($(this).find('input[type="checkbox"]'))
            }
        }
    });

    transferTable.on('change', 'input.transfer-input', function () {
        if ($(this).prop('checked')) {
            $(this).closest('tr').addClass('selected');
        } else {
            $(this).closest('tr').removeClass('selected');
        }

        let container = $(this).closest('.transfer-container');
        checkButtonsState(container);
        handleCheckAllStateChange($(this).closest('table').find('.transfer-check_all'));
    })

    $('.transfer-right').click(function () {
        let container = $(this).closest('.transfer-container');

        let table = container.find('.transfer-table-source').DataTable();
        let destinationTable = container.find('.transfer-table-destination').DataTable();

        let checked = table.find('input.transfer-input:checked');
        for (let input of checked) {
            input = $(input);

            let row = table.api().row(input.closest('tr'));
            let newRow = destinationTable.api().row.add(row.data());
            row.remove();

            if(input.data('origin') === 'source') {
                $(destinationTable.api().cell(newRow.index(), 0).node()).find('input[type="checkbox"]').removeClass('transfer-source-input').addClass('transfer-destination-input');
            }

            $(`.form-transfer[data-for="${container.data('for')}"]`).append(`<input type="hidden" name="${input.data('name')}" value="${input.val()}" class="transfer-hidden" />`);
        }

        destinationTable.api().draw();
        table.api().draw();

        updateCounter(container.data('for'));
    })

    $('.transfer-left').click(function () {
        let container = $(this).closest('.transfer-container');

        let table = container.find('.transfer-table-destination').DataTable();
        let sourceTable = container.find('.transfer-table-source').DataTable();

        let checked = table.find('input.transfer-input:checked');
        for (let input of checked) {
            input = $(input);

            let row = table.api().row(input.closest('tr'));
            let newRow = sourceTable.api().row.add(row.data());
            row.remove();

            if(input.data('origin') === 'destination') {
                $(sourceTable.api().cell(newRow.index(), 0).node()).find('input[type="checkbox"]').removeClass('transfer-destination-input').addClass('transfer-source-input');
            }

            newRow.$('.transfer-hidden').remove();

            $(`.form-transfer[data-for="${container.data('for')}"]`).find(`.transfer-hidden`).each(function() {
                if($(this).val() === input.val()) {
                    $(this).remove();
                }
            })
        }

        sourceTable.api().draw();
        table.api().draw();

        updateCounter(container.data('for'));
    })

    transferTable.each(function () {
        $(this).DataTable({
            dom: '<"transfer-search"f><t>',
            paging: false,
            // scrollY: $(this).closest('.transfer-container').data('max_height') + 'px',
            // scrollCollapse: true,
            language: {
                search: '',
                searchPlaceholder: $(this).closest('.transfer-container').data('search_placeholder')
            },
            fnRowCallback: (row) => {
                $(row).addClass('transfer-element');
            },
            drawCallback: () => {
                handleCheckAllStateChange($(this).closest('table').find('.transfer-check_all'));

                let container = $(this).closest('.transfer-container');
                checkButtonsState(container)
            }
        });
    })

    transferContainer.each(function() {
        $(".transfer-hidden").appendTo($(`.form-transfer[data-for="${$(this).data('for')}"]`));

        const adjustSize = () => {
            let isInBigModal = false;
            let modal = $(this).closest('.modal.modalTransfer__modal');
            let hasClass = modal.find('.modal-dialog').hasClass('modal-lg') || modal.find('.modal-dialog').hasClass('modal-xl');

            if(modal.length > 0 && hasClass && $(window).outerWidth() > 991) {
                isInBigModal = true;
            }

            let width = $(this).parent().innerWidth();
            if(width < 568 && !(width === 0 && isInBigModal)) {
                $(this).addClass('transfer-container-sm');
            } else {
                $(this).removeClass('transfer-container-sm');
            }

            let tables = $(this).find('table');
            for(let table of tables) {
                $(table).DataTable().api()
                    .columns.adjust()
                    .responsive.recalc()
            }
        }
        adjustSize();

        $(window).resize(function() {
            adjustSize()
        })
    })
}

// TinyMCE
$('textarea.tinymce').each(function() {
    let plugins = ['table', 'lists', 'code', 'link'];

    if($(this).data('height') === 'auto') {
        plugins = [...plugins, 'autoresize'];
    }

    let safe = $(this).data('safe') ?? false;

    tinymce.init({
        language: 'pl',
        target: this,
        width: '100%',
        height: $(this).data('height'),
        plugins,
        inline_styles: $(this).data('inline'),
        branding: false,
        verify_html: safe,
        toolbar: `undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | ${safe ? '' : 'code'}`
    });
})

// Group selects
$('select[data-group="true"]').each(function() {
    let options = $(this).find('option');

    let _value = $(this).val();
    let _options = options.clone();

    try {
        $(this).empty();

        let ungrouped = [];
        let grouped = [];

        for(let option of options) {
            let key = $(option).data('group_key');
            let objectKey = '_' + key;

            if(typeof key == 'undefined') {
                ungrouped = [...ungrouped, option]
            } else {
                if(typeof grouped[objectKey] == 'undefined') {
                    grouped[objectKey] = [];
                }

                grouped[objectKey] = [...grouped[objectKey], option];
            }
        }

        let groups = [];
        for(let group of Object.values(grouped)) {
            if(group.length > 0) {
                let name = $(group[0]).data('group_name');
                groups = [...groups, $(`<optgroup label="${name}" />`).append(group)];
            }
        }

        $(this).append(ungrouped, groups);

    } catch(err) {
        console.log(err)
        $(this).empty().append(_options).val(_value);
    }
})

// Color inputs
$('.form-control-color-input').change(function() {
    const errorField = $(this).closest('form').find(`span.error[data-for="${$(this).attr('name')}"]`);
    errorField.text('');

    if(!validateHTMLColorHex($(this).val())) {
        errorField.text('Wprowadzono niepoprawny kolor. Kolor powinien być w formacie heksadecymalnym, np. #114e00')
        return;
    }

    $(this).parent().find('.form-control-color').val($(this).val())
})

$('.form-control-color')
    .each(function() {
        $(this).parent().find('.form-control-color').val($(this).val()).trigger('change');
    })
    .change(function() {
        $(this).parent().find('.form-control-color-input').val($(this).val()).trigger('change');
    })
